<template>
	<div class="campusBox">
		<!-- 背景是图片 -->
		<div class="tnavListBox">
      <div class="tnavList">
        <router-link :to="{name:'NewListCon',query:{id:5001,pageNum:0,maxPageNum:2}}" class="tnavListLi" @click.native="refresh" key="0">新闻中心</router-link>
        <router-link :to="{name:'NewListCon',query:{id:5002,pageNum:0,maxPageNum:2}}" class="tnavListLi" @click.native="refresh" key="1">公益动态</router-link>
        <router-link :to="{name:'NewListCon',query:{id:5003,pageNum:0,maxPageNum:2}}" class="tnavListLi" @click.native="refresh" key="2">党建专栏</router-link>
      </div>
      <!-- <top-shadow class="topShadow"></top-shadow> -->
    </div>
    <router-view v-if="isRouterAlive" /> 
	</div>
</template>
<script>
import '../../../static/js/swiper.min.js'
export default {
  name: 'Home',
  data () {
    return {
      isRouterAlive:true
    }
  },
  created() {
    
  },
  mounted(){
    if(document.getElementsByClassName("tnavListLi")[1].classList.contains("router-link-exact-active") || document.getElementsByClassName("tnavListLi")[2].classList.contains("router-link-exact-active")){

    }else{
      document.getElementsByClassName("tnavListLi")[0].classList.add("router-link-exact-active")
    }    
  },
  methods: {
    refresh:function(){
      // console.log(this.$route.query.id)
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true))
    }
  }
}

</script>
<style scoped>
.campusBox{
	width: 100%;
  height: 100%;
}	
a{
  color: #333;
}
.tnavListBox{
  overflow: hidden;
  width: 100%;
  overflow-x: scroll;
  position: fixed;
  top: 3.2rem;
  background: #fff;
  height: 2.3rem;
  line-height: 1.5rem;
  box-shadow: 0 0 18px rgba(42, 42, 42, 0.1); 
  z-index: 9; 
}
.tnavListLi{
  padding: 0.6rem 0;
  margin:0 2.2rem;
  font-size: 0.9333rem;
  color: #bfbfbf;
}
.tnavListBox::-webkit-scrollbar {/*滚动条整体样式*/
  width: 0.1rem;     /*高宽分别对应横竖滚动条的尺寸*/
  height: 0.1rem;
}
.router-link-exact-active{
  color: #333;
  border-bottom: 2px solid #ff7800;
}
</style>


// WEBPACK FOOTER //
// src/components/newList/NewList.vue